<app-main-content-card>
  <router-outlet></router-outlet>
</app-main-content-card>
